import React from 'react';
import { Link } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';

const AdminProfile = ({ user, setUser }) => {
    // Function to handle user logout
    const handleLogout = () => {
        signOut(auth)
            .then(() => {
                setUser(null); // Clear user state on successful logout
            })
            .catch((error) => {
                console.error('Error logging out: ', error); // Log any errors
            });
    };

    // Debug: Print the user object
    console.log('AdminProfile user:', user);

    return (
        <div className="admin-profile">
            <h2>Admin Profile</h2>
            {user ? (
                <div>
                    <p><strong>Name:</strong> {user.username}</p>
                    <p><strong>Email:</strong> {user.email}</p>
                    <Link onClick={handleLogout} className='logout-link'>Logout</Link>
                </div>
            ) : (
                <p>Loading user information...</p>
            )}
        </div>
    );
};

export default AdminProfile;
